import { AxiosError } from 'axios';
import toast from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';

import { ApiResponse } from 'types';
import useModal from 'hooks/useModal';
import deleteUser from 'api/user/deleteUser';
import deleteUserSchema from 'schemas/deleteUserSchema';

interface FormValues {
  password: string;
}

const useDeleteUser = () => {
  const modal = useModal();
  const useFormReturn = useForm<FormValues>({
    resolver: yupResolver(deleteUserSchema),
  });

  const deleteMutation = useMutation({
    mutationFn: deleteUser,
    onSuccess: () => {
      modal.close();
      window.location.href = process.env.REACT_APP_WEB_URL as string;
    },
    onError: (error: AxiosError<ApiResponse>) => {
      if (error?.response?.data?.errorCode === 11009) {
        return useFormReturn.setError('password', { message: '비밀번호가 일치하지 않습니다.' });
      }
      toast.error('잠시후 다시 시도해주세요');
    },
  });

  const onValid = ({ password }: FormValues) => {
    deleteMutation.mutate({ password });
  };

  return {
    useFormReturn,
    isLoading: deleteMutation.isPending,
    onValid,
  };
};

export default useDeleteUser;
